export const environment = {
  production: true,
  apiUrl: "https://api.speedspot.org",
  ipUrl: "https://api.speedspot.org/ip",
  ispUrl: "https://net.speedcheck.org/isp",
};
